// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"545":"d1f0fa22","647":"fabda464","710":"ec6a8085","806":"a4da75b4"}[chunkId] + ".chunk.css";
};